import React, { useEffect, useState } from 'react';

function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    if (isStandalone()) {
      setInstalled(true);
      return undefined;
    }

    const onInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferredPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', onInstall);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onInstall);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (installed || dismissed) return null;

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  return (
    <div className="mps-install-banner">
      <div className="mps-install-banner-inner">
        <div>
          <strong>Install MPS App</strong>
          <p>
            {deferredPrompt
              ? 'Add MODERN PUBLIC SCHOOL to your home screen for quick access like a native app.'
              : isIos()
                ? 'On iPhone: tap Share, then "Add to Home Screen".'
                : 'Open in Chrome on Android and use the browser menu → Install app / Add to Home screen.'}
          </p>
        </div>
        <div className="mps-install-actions">
          {deferredPrompt ? (
            <button type="button" className="mps-btn mps-btn-sm" onClick={handleInstall}>
              Install
            </button>
          ) : null}
          <button type="button" className="mps-btn mps-btn-secondary mps-btn-sm" onClick={() => setDismissed(true)}>
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}
